import React from "react";
import Brand from "./Brand/Brand";
import brand1 from "../../resources/brands1.png";
import brand2 from "../../resources/brands2.png";
import brand3 from "../../resources/brands3.png";
import brand4 from "../../resources/brands4.png";
import brand5 from "../../resources/brands5.png";
import "./HomeSectionSix.css";

const brands = [
  { img: brand1 },
  { img: brand2 },
  { img: brand3 },
  { img: brand4 },
  { img: brand5 },
];

function HomeSectionSix() {
  return (
    <div className="homeSectionSix">
      <div className="homeSectionSix__brands">
        {brands.map(({ img }) => {
          return <Brand img={img} />;
        })}
      </div>
    </div>
  );
}

export default HomeSectionSix;
